import React from "react";
import { Container } from "react-bootstrap";
import { useIsMobile } from "../../utils/responsive";
export default function Banner5() {
  const isMobile = useIsMobile();
  return (
    <Container fluid className="p-0">
      <div className="d-flex justify-content-center">
        {!isMobile && (
          <div
            style={{
              width: "5%",
              // borderTop: "1px solid black",
              borderBottom: "1px solid black",
              borderRight: "1px solid black",
              // borderLeft: "1px solid black",
            }}
          ></div>
        )}
        <div
          style={{
            width: isMobile ? "100%" : "90%",
            // borderTop: "1px solid black",
            borderBottom: "1px solid black",
            // borderRight: "1px solid black",
            // borderLeft: "1px solid black",
            alignItems: "center",
          }}
        >
          <div
            style={{
              padding: isMobile ? "20px 40px" : "40px 150px",
            }}
          >
            <p className="body-lg m-0 text-center">
              <span className="accent-text">Kritika’s work&nbsp;</span>
              is a testament to her belief that true luxury lies in the
              intersection of beauty, functionality, and emotional depth. With a
              sharp strategic acumen—rooted in her commerce education—she
              anticipates industry shifts, crafting solutions that cater to
              evolving client aspirations. Her ability to merge innovation with
              timeless elegance sets her apart, positioning her as a trailblazer
              in the industry.
            </p>
            <br />
            <br />
            <p className="body-lg m-0 text-center">
              As she continues to push the boundaries of design, Kritika remains
              committed to creating immersive spaces that are not merely
              visually compelling, but also imbued with purpose, wellness, and a
              profound sense of individuality.
            </p>
          </div>
        </div>
        {!isMobile && (
          <div
            style={{
              width: "5%",
              // borderTop: "1px solid black",
              borderBottom: "1px solid black",
              // borderRight: "1px solid black",
              borderLeft: "1px solid black",
            }}
          ></div>
        )}
      </div>
    </Container>
  );
}
